import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck, FiArrowUpRight } = FiIcons;

function AnswerCard({ answer, index, selected, correct, answered, onSelect }) {
  const state = answered
    ? correct
      ? 'correct'
      : selected
        ? 'selected-wrong'
        : 'muted'
    : 'idle';

  return (
    <motion.button
      type="button"
      className={`answer-card answer-card--${state}`}
      onClick={() => onSelect(index)}
      disabled={answered}
      aria-pressed={selected}
      whileHover={answered ? {} : { x: 4 }}
      whileTap={answered ? {} : { scale: 0.99 }}
    >
      <span className="answer-letter">{String.fromCharCode(65 + index)}</span>
      <span className="answer-text">{answer}</span>
      <span className="answer-icon" aria-hidden="true">
        <SafeIcon icon={answered && correct ? FiCheck : FiArrowUpRight} />
      </span>
    </motion.button>
  );
}

export default AnswerCard;